class ValidarDadosGerais {
    validarAmparoLegal(licitacao){
        return !!(licitacao.amparoLegal && licitacao.idAmparoLegal);
    }

    validarComissao(licitacao){
        return !!licitacao.idComissaoApuracao;
    }
}

export default new ValidarDadosGerais()
